import { Button } from '@mui/material'
import React from 'react'

const CustomButton = ({
  title,
  width,
  height,
  color,
  fontSize,
  background,
  border,
  borderRadius,
  fullWidth,
  padding,
  marginTop,
  onClick,
  className
}) => {
  return (
    <Button
      style={{
        height: height ? height : '37px',
        width: width ? width : '',
        background: background
          ? background
          : 'transparent linear-gradient(180deg, #01CED1 0%, #14B1E4 44%, #2992FB 100%)',
        fontSize,
        color: color ? color : '#fff',
        border,
        padding: padding ? padding : '',
        borderRadius: borderRadius ? borderRadius : '',
        marginTop: marginTop ? marginTop : '',
        textTransform: 'capitalize',
      }}
      className={className}
      disableElevation
      fullWidth={fullWidth}
    >
      {title}
    </Button>
  )
}

export default CustomButton
